
var id = "unbind-icon";
var markup = "<symbol viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"unbind-icon\">\n<circle cx=\"8.93835\" cy=\"8\" r=\"7.25\" stroke=\"#1565C0\" stroke-width=\"1.5\" />\n<g clip-path=\"url(#unbind-icon_clip0_1937_16681)\">\n<path d=\"M9.33271 6.34009L7.71226 4.71963C7.11561 4.123 6.16821 4.10307 5.59615 4.67513C5.02409 5.24719 5.04402 6.19459 5.64065 6.79124L7.26111 8.41169\" stroke=\"#1565C0\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M10.5876 7.59766L12.2081 9.21811C12.8047 9.81474 12.882 10.7336 12.2526 11.3342C11.6231 11.9348 10.7331 11.8863 10.1364 11.2897L8.51599 9.66926\" stroke=\"#1565C0\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M8.36309 7.39128L7.55286 6.58105\" stroke=\"#1565C0\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M10.2536 9.28093L9.44336 8.4707\" stroke=\"#1565C0\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n<defs>\n<clipPath id=\"unbind-icon_clip0_1937_16681\">\n<rect width=\"10\" height=\"10\" fill=\"white\" transform=\"translate(3.93835 3)\" />\n</clipPath>\n</defs>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
